import { personRefProjection } from './personRef.query';

export const testimonialRefName = 'testimonialRef';

export const testimonialRefProjection = `{
    _id,
    backgroundImage,
    quote,
    person {
      reference -> ${personRefProjection}
    },
    link,
}`;

export const testimonialRefQuery = groq`*[_id == $_id && _type == "testimonial"][0] ${testimonialRefProjection}`;
